const API_ENDPOINT = "http://localhost:5001"
export default API_ENDPOINT;